import React from 'react'
import profileStyle from './authorprofileInfo.module.css'
import { TfiWorld } from "react-icons/tfi";
import { LuUpload } from "react-icons/lu";
import { GoHeartFill } from "react-icons/go";
require('typeface-poppins')


export default function AuthorprofileInfo({mobilImg}) {

    return (
    <>
        <div className={profileStyle.pictureboxview}>
            <div className={profileStyle.picturepreviewview}>
                <div className={profileStyle.imageWrapview}>
                    <img src={mobilImg} className='img-fluid w-100 h-100'  /> 
                </div>
            </div>
            <div className={profileStyle.picturemainTextview}>                 
                <div className={`${profileStyle.profileOvericons} d-flex justify-content-end align-items-end`}>
                    <div className={`${profileStyle.authorName} w-100`}>
                        <h5>Elliot Finch</h5>
                    </div>   
                    <div className='d-flex justify-content-between align-items-center'>
                        <button className={`${profileStyle.webIconbtn} btn btn-danger`}> <TfiWorld className={profileStyle.globeIcon} /> </button>
                        <button className={`${profileStyle.webIconbtn} btn btn-danger ms-3`}> <LuUpload className={profileStyle.uploadIcon} /> </button>
                        <button className={`${profileStyle.webIconbtn} btn btn-danger ms-3`}> <GoHeartFill className={profileStyle.heartIcon} /> </button>
                    </div>                    
                </div>
            </div>
        </div>       
    </>
  )
}